module.exports = __webpack_public_path__ + "img/wheel_buyfeature_super_bg.8f7ddc1b.png";